import React, { createContext, useContext } from 'react';

/**
 * v2 is UCS-only and has NO socket.io server: the on-prem print agent works
 * through the `print_jobs` queue and all "live" dashboards refresh via
 * react-query polling (refetchInterval). v1 opened a socket.io connection here,
 * which against the v2 API produced an endless stream of
 * `GET /socket.io/?... 404 (Not Found)`.
 *
 * We keep the `useSocket()` / `<SocketProvider>` API as a no-op so existing
 * consumers (e.g. AdminShell's agent indicator) compile unchanged; `connected`
 * stays false, which AdminShell renders as "Agent on-prem · offline (kolejka)"
 * — the correct wording for the queue-based model.
 */

interface SocketContextType {
  socket: null;
  connected: boolean;
}

const SocketContext = createContext<SocketContextType>({
  socket: null,
  connected: false,
});

export const useSocket = () => useContext(SocketContext);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <SocketContext.Provider value={{ socket: null, connected: false }}>
    {children}
  </SocketContext.Provider>
);
